import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "ionic-angular";
import { SelectContactControlComponent } from "./select-contact-control.component";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild()
    ],
    declarations: [
        SelectContactControlComponent
    ],
    exports: [
        SelectContactControlComponent
    ]
})
export class SelectContactControlModule {

    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SelectContactControlModule
        };
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/select-contact/form/select-contact-control.module.ts